// extracted by mini-css-extract-plugin
export default {"wrapper":"StaticHero_wrapper__FibFH","title":"StaticHero_title__HkM4L","subtitle":"StaticHero_subtitle__nth49","btn":"StaticHero_btn__ydUV+"};